import { styled } from '@linaria/react';

export const AppWrapper = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: var(--background-color);
    color: var(--text-color);
`;

export const PageWrapper = styled.div`
    overflow: hidden;
    position: relative;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const ContentWrapper = styled.div`
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: var(--content-background);
`;

export const PageHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--header-background);
    border-bottom: 1px solid var(--border-color);
    position: sticky;
    top: 0;
    z-index: 5;

    @media (max-width: 768px) {
        padding: 0 15px;
        height: 50px;
    }
`;

export const MainContentWrapper = styled.div`
    @media (max-width: 768px) {
        padding: 10px;
    }
`;

export const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--background-color);
`;

export const ErrorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--background-color);
    color: var(--error-color);
    text-align: center;
    padding: 15px;
`;
